import { DataTable } from "@/components/datatable/datatable"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Page, PageTitle } from "@/components/page"
import { usePage } from "@/components/page/hooks"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { ContactRender } from "./contact"
import { useCallback } from "react"

const RoleMaps = {
  user: "User",
  assistant: "Assistant",
  human: "Human",
  synthetic: "Synthetic",
}
const ChannelMaps = {
  telerivet: "Telerivet",
  app: "App",
  whatsapp: "WhatsApp",
  messenger: "Facebook Messenger",
  instagram: "Instagram",
  telegram: "Telegram",
}


const columns: Columns<Message> = {
  contact: { header: "Contact", size: 120, cell: ({ row }) => <ContactRender contact={row.original.contact as any} /> },
  message: { header: "Message", size: 950 },
  role: { header: "Role", size: 120, cell: ({ row }) => RoleMaps[row.original.role] || "Unknown" },
  channel: { header: "Channel", size: 120, cell: ({ row }) => ChannelMaps[row.original.channel] || "Unknown" },
  agent: { header: "Agent", size: 120, cell: ({ row }) => (row.original.agent as any)?.title || "Unknown" },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

export function MessagesListComponent() {

  const { team, } = usePage()
  const filter = useCallback(q => q.eq("team", team?.id), [team])

  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
      </div>
      <DataTableSupabase
        table="messages"
        columns={columns}
        sort={["created_at", "desc"]}
        enableServerSideFiltering={true}
        showSearch={false}
        realtime
        filter={filter}
        select={`
        *,
        agent (
          title
        ),
        contact (
          *
        )
      `}
      />
    </div>
  </Page>
}
